import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  newsList: AngularFireList<any>;
  noticesList: AngularFireList<any>;
  eventsList: AngularFireList<any>;

  constructor(private firebase: AngularFireDatabase) { }

  getNewsList() {
    this.newsList = this.firebase.list('news');
    return this.newsList;
  }

  getNoticesList() {
    this.noticesList = this.firebase.list('notices');
    return this.noticesList;
  }

  getEventsList() {
    this.eventsList = this.firebase.list('events');
    return this.eventsList;
  }
}
